import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'
import { ClientCount, ClientCountByDay } from './types'

export const clientCountMounted = createEvent()

export const getClientCount = fx<void, ClientCount>({
  method: 'GET',
  url: '/client/count',
})

export const getClientCountByDay = fx<void, ClientCountByDay[]>({
  method: 'GET',
  url: '/client/count-by-month',
})

export const $clientCount = restore<ClientCount>(
  getClientCount.doneData.map((doneData) => doneData.body),
  { count: 0 },
)

export const $clientCountByDay = restore<ClientCountByDay[]>(
  getClientCountByDay.doneData.map((doneData) => doneData.body),
  [], // начальное состояние пустой массив
)

sample({
  clock: [clientCountMounted],
  source: $params,
  fn: () => ({}),
  target: [getClientCount],
})

sample({
  clock: [clientCountMounted],
  source: $params,
  fn: () => ({}),
  target: [getClientCountByDay],
})
